/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/credentialLists.config.json";
// import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_POLICY_LIST } from "../graphql";
import { VApplication } from "../../../application";

import { useEventId } from "../provider";
import moment from "moment";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPolicyListsMethods extends IPluginMethodMap {
  getPolicyListsProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class PolicyListsService implements IAgentPlugin {
  readonly methods: IPolicyListsMethods;

  constructor() {
    this.methods = {
      getPolicyListsProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    console.log(`args in service:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { eventId } = useEventId();
    let _where1 = args?.where?.filter(
      (item) => item?.column === "policyNumber" || item?.column ==="status"
    );
    let _where2 = args?.where?.filter(
      (item) => item?.column !== "policyNumber" && item?.column !== "status"
    );
    try {
      if (client) {
        const res = await client.query({
          query: GET_POLICY_LIST,
          variables: {
            input: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
              order: [
                {
                  column:"updatedAt",
                  direction:"DESC"
                }
              ],
              where: [
                {
                  column: "cyclone",
                  value: [eventId],
                  op: "Equal",
                },
                ..._where1,
              ],
              relationFilter: {
                purchaser: {
                  where: [..._where2],
                  limit: args?.size ?? 10,
                  skip: args?.offset ?? 0,
                },
              },
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatTable(res?.data?.getListOfPayout?.data);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getListOfPayout?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfPayout?.currentPage,
            pageSize: res?.data?.getListOfPayout?.pageSize,
            totalCount: res?.data?.getListOfPayout?.totalCount,
            totalPages: res?.data?.getListOfPayout?.totalPages,
          };
        }
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          vid: item?.purchaser?.vuid,
          status:item?.status,
          payout:item?.amount,
          policyNo: item?.policyNumber,
          name: `${item?.purchaser?.firstName} ${item?.purchaser?.lastName}`,
          email: item?.purchaser?.email,
          // image:item?.image,
          dateCreated: item?.policy?.purchasedAt
            ? moment(item?.policy?.purchasedAt).format("LLL")
            : "-",
          coverage: item?.policy?.coverage,
          premium: item?.policy?.premium,
          policyOption: `Policy Option ${item?.policy?.productDefination}`,
        };
      });
    return _rowData;
  }
  // return { ...(config || {}) };
}
